import { AutoComplete, DatePicker as AntDatePicker } from "antd";
import styled from "styled-components";
import { device } from "../../globalAssets/breakpoints";
import { desktop } from "../../globalAssets/fontsize";

export const StepsContainer = styled.div`
  position: absolute;
  justify-content: center;
  display: flex;
  align-items: center;
  margin: 10px auto;
  bottom: 20px;
  width: 40%;
  right: 30%;
  & > hr {
    padding: 0 !important;
    /* width: 95%; */
    margin: 0 !important;
    align-self: center;
    margin-bottom: 20px;
    flex: 1;
    outline: none;
    margin-right: 10px;
    margin-left: 10px;
    border: ${(props) => `1px solid ${props.theme.color}`};
  }
  @media ${device.laptop} {
    position: fixed;
    bottom: 3.5vw;
    width: 10%;
    right: 17.5%;
    height: 3vw;
    padding: 0 15px;
    display: flex;
    align-items: center;
    margin: 10px auto;
    & hr {
      padding: 0 !important;
      margin: 0 !important;
      align-self: center;
      margin-bottom: 20px;
      flex: 1;
      outline: none;
      margin-right: 10px;
      margin-left: 10px;
      /* color: ${(props) => `1px solid ${props.theme.color}`}; */
    }
  }
`;
interface StepCountType {
  active: boolean;
}
export const StepCount = styled.div<StepCountType>`
  font-weight: 500;
  color: ${(props) => (props.active ? props.theme.color : props.theme.grey)};
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 1.5vw;
  padding: 0;
  width: 20px;
  margin: 0 auto;
  font-size: 16px;
  @media ${device.laptop} {
    font-size: ${desktop.small};
    width: 1.5vw;
  }
`;

export const Skip = styled.p`
  color: ${(props) => props.theme.primaryColor};
  font-weight: 500;
  cursor: pointer;
  text-align: center;
  margin: 7px 0;
  font-size: 15px;
  @media ${device.laptop} {
    font-size: ${desktop.normal};
  }
`;

export const StyledAutoComplete = styled(AutoComplete)`
  &&& {
    outline: none;
    border: none !important;
    width: 100%;
    height: 100%;
    font-size: 14px;
    background: ${(props) => props.theme.foreground};
    color: ${(props) => props.theme.color};

    .ant-select-selector,
    .ant-select {
      background: ${(props) => props.theme.foreground};
      color: ${(props) => props.theme.color};
      font-size: 14px;
      border: none;
      outline: none;
      height: 100%;
      :hover,
      :active,
      :focus {
        border: none !important;
      }
    }
    .ant-select:not(.ant-select-customize-input)
      .ant-select-selector
      .ant-select:not(.ant-select-customize-input)
      .ant-select-selection-search-input {
      height: 100%;
      background: ${(props) => props.theme.foreground};
    }
    @media ${device.laptop} {
      height: 100%;
      font-size: ${desktop.small};
      .ant-select-selector,
      .ant-select {
        background: ${(props) => props.theme.foreground};
        font-size: ${desktop.small};
      }
    }
  }
`;

export const InputDiv = styled.div`
  width: 100%;
  height: 40px;
  border: 1px solid ${(props) => props.theme.subtleBlack};
  border-radius: 4px;
  padding: 0vw 0vw;
  :active,
  :focus,
  :hover {
    border: 2px solid ${(props) => props.theme.primaryColor};
  }
  @media ${device.laptop} {
    height: 2.5vw;
    :active,
    :focus,
    :hover {
      border: 1px solid ${(props) => props.theme.primaryColor};
    }
  }
`;

export const StyledDataPicker = styled(AntDatePicker)`
  &&& {
    border: 1px solid ${(props) => props.theme.subtleBlack};
    height: 40px;
    padding: 5px 10px;
    outline: none !important;
    background: ${(props) => props.theme.foreground};
    color: ${(props) => props.theme.color};
    font-size: 14px;
    width: 100%;
    :active,
    :focus,
    :hover {
      border: 1px solid ${(props) => props.theme.primaryColor};
    }
    .ant-picker-suffix {
      color: ${(props) => props.theme.color};
    }
    .ant-picker-focused,
    .ant-picker {
      border: none !important;
      outline: none !important;
      :focus,
      :active,
      :hover {
        border: none !important;
        outline: none !important;
      }
    }
    input {
      color: ${(props) => props.theme.color};
    }
    @media ${device.laptop} {
      height: 2.5vw;
      font-size: ${desktop.small};
      /* border: none !important; */
      cursor: pointer;

      font-size: ${desktop.small};
    }
  }
`;

export const Dropdown = styled.select`
  &&& {
    border: none;
    background: ${(props) => props.theme.foreground};
    width: 100%;
    padding: 5px 10px;
    outline: none;
    height: 100%;
    color: ${(props) => props.theme.color};
    font-size: 14px !important;

    @media ${device.laptop} {
      /* background-color: re; */
      font-size: ${desktop.small} !important;
      /* height: 2.5vw; */
      cursor: pointer;
      &:focus,
      &:active {
        font-size: ${desktop.small};
        outline: none;
        border: none;
      }
    }
  }
`;

// const IconContainer = styled.div`
//   font-size: 1.2vw;
//   margin: 0;
//   color: ${theme.grey};
//   display: flex;
//   align-items: center;
// `;

export const Option = styled.option`
  background-color: ${(props) => props.theme.foreground} !important;
  font-size: 14px !important;
  @media ${device.laptop} {
    font-size: ${desktop.small} !important;
  }
`;
